"use client";
import DynamicYield from ".";
import { logError } from "@jetblue/dotcom-fe-logger";
import { useEffect } from "react";

export const DynamicYieldClient = ({
  sectionId,
}: {
  sectionId: string | undefined;
}) => {
  useEffect(() => {
    if (!sectionId) {
      sectionId = "8791799";
      void logError({
        message: "DynamicYieldService initialized without sectionId defined",
      });
    }
    const dynamicAPITypes = ["dynamic", "static"];
    for (const apiType of dynamicAPITypes) {
      const script = document.createElement("script");
      script.src = `https://cdn.dynamicyield.com/api/${sectionId}/api_${apiType}.js`;

      document.head.append(script);
    }
    DynamicYield.init();
  }, [sectionId]);
  return null;
};
